'use client'

import { type ComponentProps } from 'react'

import { useController } from 'react-hook-form'

import { useFormField } from '@/shared/ui/form'
import { Input as UIInput } from '@/shared/ui/input'

type InputProps = Omit<ComponentProps<'input'>, 'defaultValue'>

export function Input({ disabled, onChange, ...props }: InputProps) {
  const { name } = useFormField()
  const {
    field,
    fieldState: { error }
  } = useController({ name, disabled })

  return (
    <UIInput
      {...props}
      {...field}
      value={field.value ?? ''}
      disabled={disabled}
      onChange={e => {
        field.onChange(e)
        onChange?.(e)
      }}
      aria-invalid={!!error}
    />
  )
}
